<template>
    <section class="section-success">
        <div class="title-section">成功案例</div>

        <div class="body">
            <div class="row">
                <div class="warpper">
                    <div
                        v-for="(item, index) in repeatedList"
                        :key="index"
                        class="item"
                    >
                        <img
                            :src="item"
                            alt=""
                        />
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="warpper">
                    <div
                        v-for="(item, index) in repeatedList"
                        :key="index"
                        class="item"
                    >
                        <img
                            :src="item"
                            alt=""
                        />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            list: [
                '/images/hzc/home/success/1.png',
                '/images/hzc/home/success/2.png',
                '/images/hzc/home/success/3.png',
                '/images/hzc/home/success/4.png',
                '/images/hzc/home/success/5.png',
                '/images/hzc/home/success/6.png',
                '/images/hzc/home/success/7.png',
                '/images/hzc/home/success/8.png',
                '/images/hzc/home/success/9.png',
                '/images/hzc/home/success/10.png',
                '/images/hzc/home/success/11.png',
            ],
        };
    },
    computed: {
        repeatedList() {
            return [...this.list, ...this.list];
        },
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.section-success {
    padding-bottom: 100px;
    overflow: hidden;

    .title-section {
        padding: 72px 0;
        font-weight: normal;
    }

    .body {
        .row {
            display: flex;

            .warpper {
                display: flex;

                .item {
                    height: 90px;
                    box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.09);
                    margin: 0 11px;

                    img {
                        display: block;
                        height: 100%;
                    }
                }
            }

            & + .row {
                margin-top: 22px;
            }

            &:nth-child(1) {
                .warpper {
                    animation: flow1 20s infinite linear;
                }
            }

            &:nth-child(2) {
                .warpper {
                    animation: flow2 20s infinite linear;
                }
            }
        }
    }
}

@keyframes flow1 {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-50%);
    }
}

@keyframes flow2 {
    0% {
        transform: translateX(-25%);
    }
    100% {
        transform: translateX(-75%);
    }
}
</style>